import React from "react";
import { TextField } from "@mui/material";

const CodeInput = ({
  value,
  onChange,
  length = 4,
  allowOnlyNumbers = false,
}) => {
  const handleChange = (event) => {
    let inputValue = event.target.value;

    if (allowOnlyNumbers) {
      inputValue = inputValue.replace(/\D/g, "");
    }

    inputValue = inputValue.slice(0, length);

    onChange(inputValue);
  };

  return (
    <TextField
      fullWidth
      autoFocus
      placeholder={"000000".slice(0, length)}
      value={value}
      onChange={handleChange}
      variant="outlined"
      label="Código de confirmação"
      inputProps={{
        maxLength: length,
        inputMode: allowOnlyNumbers ? "numeric" : "text",
        sx: {
          fontSize: 20,
          fontWeight: 700,
          letterSpacing: "0.22em",
          textAlign: "center",
        },
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#ffffff",
          borderRadius: "10px",
          height: 54,
          "& fieldset": {
            borderColor: "#cbd6e2",
          },
          "&:hover fieldset": {
            borderColor: "#aebdce",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#5f48f6",
            borderWidth: "1px",
          },
        },
        "& .MuiInputLabel-root": {
          color: "#475569",
          fontSize: 14,
          "&.Mui-focused": {
            color: "#5f48f6",
          },
        },
      }}
    />
  );
};

export default CodeInput;
